import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPage.css';

const Fornitori = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <div className="header-section">
          <Link to="/" className="back-link">← Torna alla Home</Link>
          <div className="logo-section">
            <img src="/com-service-logo.png" alt="COM Service Logo" className="logo" />
          </div>
        </div>

        <div className="document-content">
          <h2>Informativa sul trattamento dei dati personali dei Fornitori</h2>
          
          <div className="content-section">
            <p>
              Ai sensi degli artt. 13 e 14 del Regolamento 2016/679/UE (nel seguito "GDPR") COM Service S.c.a.r.l (nel
              seguito "Titolare") con Via Isonzo 6 – 22078 Turate (CO), nella sua veste di "Titolare del trattamento", La
              informa che i Suoi dati personali raccolti ai fini della conclusione del contratto col Fornitore e/o nell'ambito
              dell'esecuzione e/o della stipula dello stesso saranno trattati nel rispetto delle normativa citata, al fine di
              garantire i diritti, le libertà fondamentali, nonché la dignità delle persone fisiche, con particolare riferimento
              alla riservatezza e all'identità personale. La informiamo che qualora le attività a lei prestate prevedano il
              trattamento di dati personali di terzi nella sua titolarità sarà sua responsabilità assicurare di aver adempiuto a
              quanto previsto dalla normativa nei riguardi dei soggetti Interessati al fine di rendere legittimo il loro
              trattamento da parte nostra.
            </p>
          </div>

          <div className="content-section">
            <h3>Origine, finalità, base giuridica e natura dei dati trattati</h3>
            <p>
              Il trattamento dei Suoi dati personali, da Lei direttamente forniti, è effettuato da COM Service S.c.a.r.l ai fini
              della conclusione del contratto col Fornitore e/o nell'ambito dell'esecuzione e/o della stipula dello stesso.
            </p>
            <p>
              Altresì, è possibile il verificarsi di un trattamento di dati personali di terzi soggetti comunicati dal Fornitore alla
              Società. Rispetto a tale ipotesi, il Fornitore si pone come autonomo titolare del trattamento e si assume i
              conseguenti obblighi e responsabilità legali, manlevando la Società rispetto a ogni contestazione, pretesa e/o
              richiesta di risarcimento del danno da trattamento che dovesse pervenire alla Società da terzi interessati.
            </p>
            <p>
              Nel rispetto della normativa vigente in materia di protezione dei dati personali e senza necessità di uno
              specifico consenso da parte dell'Interessato, i Dati saranno archiviati, raccolti e trattati dalla Società per i
              seguenti fini:
            </p>
            <ul>
              <li>
                <strong>a)</strong> adempimento a obblighi contrattuali, esecuzione e/o stipulazione del contratto col Fornitore e/o
                gestione di eventuali misure precontrattuali;
              </li>
              <li>
                <strong>b)</strong> assolvimento a eventuali obblighi normativi, alle disposizioni fiscali e tributarie derivanti dallo
                svolgimento dell'attività d'impresa e a obblighi connessi ad attività amministrativo-contabili;
              </li>
            </ul>
            <p>
              Le basi giuridiche del trattamento per le finalità a) e b) sopra indicate sono gli artt. 6.1.b) e 6.1.c) del
              Regolamento.
            </p>
            <p>
              Il conferimento dei Dati per i suddetti fini è facoltativo, ma l'eventuale mancato conferimento dei Dati stessi e
              il rifiuto a fornirli comporterebbero l'impossibilità per la Società di eseguire e/o stipulare il contratto ed
              erogare le prestazioni richieste dallo stesso.
            </p>
          </div>

          <div className="content-section">
            <h3>Comunicazione</h3>
            <p>
              I dati potranno essere comunicati a soggetti terzi nominati responsabili del trattamento ai sensi dell'articolo 28
              del GDPR e in particolare a istituti bancari, a società attive nel campo assicurativo, a fornitori di servizi
              strettamente necessari allo svolgimento dell'attività d'impresa, ovvero a consulenti dell'azienda, ove ciò si
              riveli necessario per ragioni fiscali, amministrative, contrattuali o per esigenze tutelate dalle vigenti normative.
            </p>
            <p>
              I Suoi dati personali, ovvero i dati personali di terzi nella sua titolarità, potranno altresì essere comunicati a
              società esterne, individuate di volta in volta, cui COM Service S.c.a.r.l affidi l'esecuzione di obblighi derivanti
              dall'incarico ricevuto alle quali saranno trasmessi i soli dati necessari alle attività loro richieste. Tutti i
              dipendenti, consulenti, interinali e/o ogni altra "persona fisica" che svolgono la propria attività sulla base delle
              istruzioni ricevute da COM Service S.c.a.r.l, ai sensi dell'art. 29 del GDPR, sono nominati "Incaricati del
              trattamento" (nel seguito anche "Incaricati"). Agli Incaricati o ai Responsabili, eventualmente designati, COM
              Service S.c.a.r.l impartisce adeguate istruzioni operative, con particolare riferimento all'adozione ed al rispetto
              delle misure di sicurezza, al fine di poter garantire la riservatezza e la sicurezza dei dati. Proprio in riferimento
              agli aspetti di protezione dei dati personali il Cliente è invitato, ai sensi dell'art. 33 del GDPR a segnalare a COM
              Service S.c.a.r.l eventuali circostanze o eventi dai quali possa discendere una potenziale "violazione dei dati
              personali (data breach)" al fine di consentire una immediata valutazione e l'adozione di eventuali azioni volte a
              contrastare tale evento inviando una comunicazione a COM Service S.c.a.r.l ai recapiti nel seguito indicati.
            </p>
            <p>
              I Dati non saranno diffusi.
            </p>
            <p>
              Resta fermo l'obbligo di COM Service S.c.a.r.l di comunicare i dati ad Autorità Pubbliche su specifica richiesta.
            </p>
          </div>

          <div className="content-section">
            <h3>Trasferimento all'estero</h3>
            <p>
              Il trasferimento all'estero dei Suoi dati personali può avvenire qualora risulti necessario per la gestione
              dell'incarico ricevuto. Per il trattamento delle informazioni e dei dati che saranno eventualmente comunicati a
              questi soggetti saranno richiesti gli equivalenti livelli di protezione adottati per il trattamento dei dati personali
              dei propri dipendenti. In ogni caso saranno comunicati i soli dati necessari al perseguimento degli scopi previsti
              e saranno applicati gli strumenti normativi previsti dal Capo V del GDPR.
            </p>
          </div>

          <div className="content-section">
            <h3>Modalità, logiche del trattamento e tempi di conservazione</h3>
            <p>
              I Suoi dati sono raccolti e registrati in modo lecito e secondo correttezza per le finalità sopra indicate nel
              rispetto dei principi e delle prescrizioni di cui all'art. 5 c 1 del GDPR.
            </p>
            <p>
              Il trattamento dei dati personali avviene mediante strumenti manuali, informatici e telematici con logiche
              strettamente correlate alle finalità stesse e, comunque, in modo da garantirne la sicurezza e la riservatezza.
            </p>
            <p>
              I Dati personali verranno trattati da COM Service S.c.a.r.l per tutta la durata dell'incarico ed anche
              successivamente per far valere o tutelare i propri diritti ovvero per finalità amministrative e/o per dare
              esecuzione ad obblighi derivanti dal quadro regolamentare e normativo pro tempore applicabile e nel rispetto
              degli specifici obblighi di legge sulla conservazione dei dati.
            </p>
          </div>

          <div className="content-section">
            <h3>Natura del conferimento</h3>
            <p>
              In relazione alle suddette finalità a) e b) sopra indicate il conferimento dei Suoi dati è indispensabile ai fini
              dell'esecuzione dell'incarico tra Lei e COM Service S.c.a.r.l e per consentire a COM Service S.c.a.r.l di dare
              seguito agli adempimenti previsti dalle normative applicabili: il mancato conferimento dei Dati stessi e il rifiuto
              a fornirli comporterebbero l'impossibilità per la Società di eseguire e/o stipulare il contratto ed erogare le
              prestazioni richieste dallo stesso. La informiamo, quindi, che il trattamento dei dati personali avviene sulla
              base delle previsioni di cui all'art. 6 c. 1 b) del GDPR.
            </p>
          </div>

          <div className="content-section">
            <h3>Diritti dell'Interessato</h3>
            <p>
              In conformità, nei limiti ed alle condizioni previste dalla normativa in materia di protezione dati personali
              riguardo l'esercizio dei diritti degli Interessati<sup>1</sup> per quanto concerne i trattamenti oggetto della presente
              Informativa, in qualità di Interessato Lei ha il diritto di chiedere conferma che sia o meno in corso un
              trattamento di suoi dati personali, accedere ai dati personali che La riguardano ed in relazione ad essi ha il
              diritto di richiederne la rettifica, la cancellazione, la notifica delle rettifiche e delle cancellazioni ai coloro i quali
              i dati sono stati eventualmente trasmessi dalla nostra Organizzazione, la limitazione del trattamento nelle
              ipotesi previste dalla norma, la portabilità dei dati personali - da Lei forniti - nei casi indicati dalla norma, di
              opporsi al trattamento dei suoi dati e, specificamente, ha il diritto di opporsi a decisioni che lo riguardano se
              basate unicamente su trattamenti automatizzati dei suoi dati, profilazione inclusa. Nel caso in cui ritenga che i
              trattamenti che La riguardano violino le norme del GDPR, ha diritto a proporre reclamo al Garante ai sensi
              dell'art. 77 del GDPR.
            </p>
            <p>
              Se intende richiedere ulteriori informazioni sul trattamento dei Suoi dati personali o per l'eventuale esercizio
              dei Suoi diritti, potrà rivolgersi per iscritto a COM Service S.c.a.r.l .
            </p>
            <div className="footnote">
              <hr />
              <p><sup>1</sup> ex Art.12 e Art. 15-22 del Regolamento 2016/679/UE</p>
            </div>
          </div>

          <div className="content-section">
            <h3>Titolare del Trattamento</h3>
            <p>
              Titolare del trattamento, ai sensi dell'art. 4 del Codice e del GDPR, è COM Service S.c.a.r.l - Via Isonzo 6 –
              22078 Turate (CO) - <a href="mailto:info@com-service.biz">info@com-service.biz</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fornitori;
